// src/services/profileService.jsx
import http from "./http";

// Get Admin Profile
export const getAdminDetails = async (id) => {
  const res = await http.post("getAdminDetails", { id });
  return res.data;
  console.log(res);
};

// Update Profile (Correct API URL + field name "photo")
export const updateAdminProfile = async (formData) => {
  const res = await http.post("updateAdminProfile", formData);
  return res.data;
};
